import { render, staticRenderFns } from "./AudioTemplate.vue?vue&type=template&id=1ccd9358&"
import script from "./AudioTemplate.vue?vue&type=script&lang=js&"
export * from "./AudioTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports